import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivelCF = props => {
  return (
    <option style={props.styles.input} value={props.elemento._id}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, handleLista, list}) => {
  const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelCF styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleES}
      </select>
    </div>
  )
};

const AddRFact2 = ({styles, handleSubmit, listaCF, handleLista, handleChange, args, errors}) => {
  const actInact = false

  return(
      <div>
          <button className="ui right labeled icon button" style={styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              Tarifa nueva
          </button>
          <div style={styles.box}>
              <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" width="100%">
                      <Form.Field>
                        <label style={styles.label}>Prefijo</label>
                        <input style={styles.input} autoComplete="off" name="prefijo" id="prefijo" onChange={handleChange} placeholder='Prefijo' icon={!errors.length?null: _find(errors, {path:'prefijo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field>
                      <Form.Field>
                        <label style={styles.label}>Número de la factura inicial</label>
                        <input type='number' step="1" min="1" style={styles.input} autoComplete="off" name="factInicial" id="factInicial" placeholder='Inicial' onChange={handleChange}/>
                      </Form.Field>
                      <Form.Field>
                        <label style={styles.label}>Número de la factura final</label>
                        <input type='number' step="1" min="1" style={styles.input} autoComplete="off" name="factFinal" id="factFinal" placeholder='Final' onChange={handleChange}/>
                      </Form.Field>
                      <Form.Field>
                        <label style={styles.label}>Número de la última factura</label>
                        <input type='number' step="1" min="0" style={styles.input} autoComplete="off" name="proxFact" id="proxFact" placeholder='Ultima' onChange={handleChange}/>
                      </Form.Field>
                      <Form.Field>
                        <label style={styles.label}>Ciclo de facturación</label>
                        <ListaCF list={listaCF} styles={styles} handleLista={handleLista} />
                      </Form.Field>
                      <Form.Field>
                        <label style={styles.label}>Fecha</label>
                        <input style={styles.input} type='date' name="fecha" id="fecha" onChange={handleChange}/>
                      </Form.Field>
                      <Form.Field>
                        <label style={styles.label}>Resolución</label>
                        <input style={styles.input} autoComplete="off" name="numResolucion" id="numResolucion" onChange={handleChange} placeholder='Resolución' icon={!errors.length?null: _find(errors, {path:'numResolucion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field>
                      <Form.Field>
                        <label style={styles.label}>Observaciones</label>
                        <input style={styles.input} autoComplete="off" name="observaciones" id="observaciones" onChange={handleChange} placeholder='Observaciones' icon={!errors.length?null: _find(errors, {path:'observaciones'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field>
                      <Form.Field>
                        <label style={styles.label}>Inactivo / Activo</label>
                        <Form.Checkbox defaultChecked={actInact} name="estadoRangoFact" id="estadoRangoFact" className='ui fitted toggle checkbox' onChange={handleChange}/>
                      </Form.Field>

                      <Button style={styles.confirmar} type='submit' fluid>
                          AGREGAR
                      </Button>

                      {
                          errors.length?<Message negative header="Los siguientes errores:"
                          list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                      }
                    </div>
                  </div>
              </div>
            </Form>
          </div>
      </div>
  )
}

export default AddRFact2
